;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { LogoName, logoSpriteHref } from '@qogita/svg-logos'
import { type SVGProps } from 'react'

import { cn } from '../../utils/cn'

export { type LogoName, logoSpriteHref }

export function Logo({
  name,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { name: LogoName }) {
  return (
    <svg
      {...props}
      className={cn(className)}
      aria-label={`${name} logo`}
      role="img"
    >
      <use href={`/sprites/logos/${logoSpriteHref}#${name}`} />
    </svg>
  )
}
